module.exports = __webpack_public_path__ + "img/pcsetup_tips.e04997eb.png";